<ion-card *mobxAutorun class="ion-no-margin ly-col ion-justify-content-between flex md-border">
  <div class="ly-col flex">
    <ion-row>
      <ion-text class="ion-padding-start ion-padding-end ion-text-center">
        <h5>{{ startDateLabel }} - {{ endDateLabel }}</h5>
      </ion-text>
    </ion-row>
    <div class="ly-row md-border-bottom header ion-justify-content-between">
      <ion-row>
        <ion-item>
          <ion-select
            (ionChange)="selectedMetric = $any($event).detail.value; getData()"
            [value]="selectedMetric"
            [interfaceOptions]="{
              size: 'auto',
              alignment: 'start'
            }"
          >
            <ion-select-option *ngFor="let option of options" [value]="option">
              {{ 'components.queueHeader.labels.' + option | translate }}
            </ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item class="ion-margin-start" *ngIf="showSpanSelector && !hidePeriod">
          <ion-select
            (ionChange)="selectedPeriod = $any($event).detail.value; setDataByPeriod()"
            [value]="selectedPeriod"
            [interfaceOptions]="{
              size: 'auto',
              alignment: 'start'
            }"
          >
            <ion-select-option *ngFor="let period of periodOptions" [value]="period">
              {{ 'components.performanceChart.labels.spanLabel' | translate: { span: period } }}
            </ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item class="ion-margin-start" *ngIf="showSpanSelector && !hideView">
          <ion-select
            (ionChange)="selectedView = $any($event).detail.value; getData()"
            [value]="selectedView"
            [interfaceOptions]="{
              size: 'auto',
              alignment: 'start'
            }"
          >
            <ion-select-option *ngFor="let view of viewOptions" [value]="view">
              {{ view | translate }}
            </ion-select-option>
          </ion-select>
        </ion-item>
      </ion-row>
      <ion-row class="ion-align-items-center flex-no-wrap">
        <div class="legend-item current md-border">
          {{ currentText }}
        </div>
        <div class="legend-item past md-border ion-margin-start">
          {{ pastText }}
        </div>
      </ion-row>
    </div>
    <ion-row class="flex ion-align-items-center chart-container ion-margin-bottom">
      <ngx-charts-line-chart
        [scheme]="$any(colorScheme)"
        [legend]="false"
        [showXAxisLabel]="false"
        [showYAxisLabel]="false"
        [xAxis]="true"
        [yAxis]="true"
        [timeline]="false"
        [results]="lineChartData"
        [xAxisTickFormatting]="xAxis"
        *ngIf="!chartIsEmpty && !isLoading"
      >
        <ng-template #tooltipTemplate let-model="model">
          <ng-template [ngTemplateOutlet]="tooltip" [ngTemplateOutletContext]="{ model: [model] }">
          </ng-template>
        </ng-template>
        <ng-template #seriesTooltipTemplate let-model="model">
          <ng-template
            [ngTemplateOutlet]="tooltip"
            [ngTemplateOutletContext]="{ model: model.reverse() }"
          >
          </ng-template>
        </ng-template>
      </ngx-charts-line-chart>
      <empty-state
        *ngIf="chartIsEmpty && !isLoading"
        [showAction]="false"
        title="components.performanceChart.messages.emptyChartTitle"
        description=""
      >
      </empty-state>
      <loading-text class="flex" *ngIf="isLoading"> </loading-text>
    </ion-row>
  </div>
  <ion-row class="stretch-x" *ngIf="!isAdmin && showLink">
    <ion-button
      class="ion-no-margin stretch-x"
      expand="full"
      [routerLink]="['/workspace/analyze']"
      [disabled]="true"
    >
      <ion-icon name="bar-chart-outline" slot="start"> </ion-icon>
      {{ 'components.performanceChart.buttons.viewAnalytics' | translate }}
    </ion-button>
  </ion-row>

  <ng-template #tooltip let-model="model">
    <div
      class="ly-col performance-chart-tooltip ion-align-items-start md-light"
      [class.md-border-bottom]="i === 0 && model.length > 1"
      *ngFor="let item of model; let i = index"
    >
      <ion-text>
        <h4>{{ item.endDate }}</h4>
      </ion-text>
      <ion-row>
        <ion-text
          *ngIf="item.currentData"
          [color]="
            item.indication === 'positive'
              ? 'success'
              : item.indication === 'noChange'
              ? 'warning'
              : 'danger'
          "
        >
          <ion-icon
            *ngIf="item.indication === 'positive' || item.indication === 'negative'"
            [name]="item.indication === 'positive' ? 'arrow-up' : 'arrow-down'"
          >
          </ion-icon>
          {{ item.change }}
        </ion-text>
        <ion-text color="light" class="value">
          {{ selectedMetric === 'earnedValue' ? '$' : '' }}{{ item.value }}
        </ion-text>
      </ion-row>
    </div>
  </ng-template>
</ion-card>
